module.exports = __webpack_public_path__ + "img/c2-4_m.5dd0cee1.png";